/// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();

/* ZEST THEME ONLY */
/* Make footer newsletter header not clickable/collapsible */
document.addEventListener('DOMContentLoaded', function () {
  const newsletter = document.querySelector(".site-footer__block--newsletter");
  const summary = newsletter.querySelector('summary');
  const details = newsletter.querySelector('details');
  if (summary && details) {
    console.log("got sum and deets");
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      details.setAttribute('open', ''); // ensure it stays open
    });
  }
});

/* Display badges in slider without product titles cutting off */ 
function adjustViewportHeight() {
  console.log("adjusting viewport height");
 
 const viewports = document.querySelectorAll('.featured-collection .flickity-enabled.is-draggable .flickity-viewport');
  viewports.forEach(viewport => {
    const currentHeight = parseFloat(viewport.style.height);
    console.log("current height is " + currentHeight);
    if (!isNaN(currentHeight)) {
      viewport.style.setProperty('height', (currentHeight + 10) + 'px', 'important');
      console.log("new height is " + viewport.style.height);
    }
  });

  const recommendations = document.querySelectorAll('.product-recommendations .flickity-enabled.is-draggable .flickity-viewport');
  recommendations.forEach(rec => {
    const currentHeight = parseFloat(rec.style.height);
    console.log("current height is " + currentHeight);
    if (!isNaN(currentHeight)) {
      rec.style.setProperty('height', (currentHeight + 10) + 'px', 'important');
      console.log("new height is " + rec.style.height);
    }
  });
}

// Run on page load with delay to ensure Flickity classes are applied
window.addEventListener('load', () => {
  setTimeout(adjustViewportHeight, 200);
});

// Run on window resize with multiple attempts
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    // Run again after Flickity finishes its resize
    setTimeout(adjustViewportHeight, 100);
  }, 150);
});
